const link = {
    active: { color: { value: '{colors.font.active.value}' } },
    color: { value: '{colors.font.interactive.value}' },
    focus: { color: { value: '{colors.font.focus.value}' } },
    hover: { color: { value: '{colors.font.hover.value}' } },
    visited: { color: { value: '{colors.font.interactive.value}' } },
};

export { link };
